<template>
	<CreationWizardStepWrapper>
		<template #header>
			<NeedPlyExtensionToUseButtonDropdownHeader v-bind="$props" v-on="$listeners" />
		</template>
		<InstallPlyExtensionLoader
			class="width-100 height-100"
			@extension-installed="nextStep"
			:minimalVersion="MINIMAL_VERSION_NEW_PLACEMENT_RELATIONS"
		/>
	</CreationWizardStepWrapper>
</template>

<script>
import WizardStepMixin from '../WizardStepMixin';
import NeedPlyExtensionToUseButtonDropdownHeader from './NeedPlyExtensionToUseButtonDropdownHeader.vue';
import props from './NeedPlyExtensionToUseButtonDropdown.props';
import InstallPlyExtensionLoader from '@/components/InstallPlyExtensionLoader.vue';
import { MINIMAL_VERSION_NEW_PLACEMENT_RELATIONS } from '@/utils/extension-communication-service.const';
export default {
	name: 'NeedPlyExtensionToUseButtonDropdown',
	mixins: [WizardStepMixin],
	props,
	components: { NeedPlyExtensionToUseButtonDropdownHeader, InstallPlyExtensionLoader },
	data() {
		return { MINIMAL_VERSION_NEW_PLACEMENT_RELATIONS };
	},
};
</script>

<style lang="scss" scoped></style>
